<template>
  <div class="form-check form-switch form-switch-xl">
    <input id="include_freeze_search" class="form-check-input" type="checkbox" :checked="value" @change="doChange($event)">
    <label class="form-check-label" for="include_freeze_search">利用不可アカウントを表示する</label>
  </div>
</template>

<script>
import BaseVuexSearchItem from '@/views/molecules/searchItems/BaseVuexSearchItem';

export default {
  name: "VuexIncludeFreezeSearchItem",
  extends: BaseVuexSearchItem,
  methods: {
    doChange(event) {
      this.value = event.target.checked;
    }
  }
}
</script>
